import Splide from '@splidejs/splide';

import { CLASSES, SELECTORS, EVENTS, DATA_ATTR } from '../config/constants';
import sliderConfigs from '../config/sliders';

export default class BaseSlider {
  constructor() {
    this.sliderInstance;
  }

  init({ sliderInstance, sliderEl }) {
    const arrowElems = sliderEl.querySelectorAll(SELECTORS.SLIDERS.ARROW);

    this.sliderInstance = sliderInstance;

    if (arrowElems.length) {
      this.setArrowsVisibility(...arrowElems);
      this.observeArrows();
    }
  }

  setArrowsVisibility(prev, next) {
    const shouldBeHidden = prev.disabled || next.disabled;
    const arrowsParent = prev.closest(SELECTORS.SLIDERS.ARROWS);

    if (shouldBeHidden) {
      arrowsParent.classList.add(CLASSES.HIDDEN);
    } else {
      arrowsParent.classList.remove(CLASSES.HIDDEN);
    }
  }

  observeArrows() {
    this.sliderInstance.on(EVENTS.SPLIDE.ARROWS_UPDATED, this.setArrowsVisibility);
  }

  getSplideInstance(el) {
    const config = this.getConfig(el);

    return new Splide(el, config);
  }

  getConfig(el) {
    const configName = el.dataset[DATA_ATTR.SLIDER.CONFIG];
    const config = sliderConfigs[configName] || sliderConfigs.default || {};

    this.config = config;

    return config;
  }
}
